'use strict';

var objectWithoutProperties = require('../../../node_modules/@babel/runtime/helpers/objectWithoutProperties.js');
var defineProperty = require('../../../node_modules/@babel/runtime/helpers/defineProperty.js');
var React = require('react');
var classNames = require('classnames');
var makeStyles = require('../../Styles/makeStyles.js');
var ObjectHelper = require('../../../common/ObjectHelper.js');
var TableRow$1 = require('../../../node_modules/@material-ui/core/esm/TableRow/TableRow.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var classNames__default = /*#__PURE__*/_interopDefaultLegacy(classNames);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var useStyles = makeStyles["default"](function (theme) {
  return {
    row: {
      '& td:first-child': {
        paddingLeft: 24
      },
      '& th:first-child': {
        paddingLeft: 24
      }
    },
    stickyCol: function stickyCol(_ref) {
      var stickyColumn = _ref.stickyColumn,
          stickyColumnColor = _ref.stickyColumnColor;
      return defineProperty({}, "& th:nth-of-type(".concat(stickyColumn || 1, "), & td:nth-of-type(").concat(stickyColumn || 1, ")"), {
        position: 'sticky',
        left: '0',
        backgroundColor: "".concat(stickyColumnColor || theme.palette.background.white),
        zIndex: 1
      });
    },
    hideRightBorder: {
      '& td:last-of-type': {
        borderRight: 'hidden'
      },
      '& th:last-of-type': {
        borderRight: 'hidden'
      }
    },
    hideTopHeaderBorder: {
      '& th:first-of-type': {
        borderTop: 'hidden'
      }
    },
    hoverStyle: function hoverStyle(_ref3) {
      var stickyColumn = _ref3.stickyColumn,
          stickyColumnColor = _ref3.stickyColumnColor;
      return defineProperty({
        backgroundColor: "".concat(stickyColumnColor || theme.palette.background.white),
        '&:hover': {
          backgroundColor: 'rgb(234, 243, 249) !important'
        }
      }, "& th:nth-of-type(".concat(stickyColumn || 1, "), & td:nth-of-type(").concat(stickyColumn || 1, ")"), {
        backgroundColor: 'inherit'
      });
    }
  };
});
var TableRow = React__default["default"].forwardRef(function (_ref5, ref) {
  var href = _ref5.href,
      target = _ref5.target,
      className = _ref5.className,
      borders = _ref5.borders,
      children = _ref5.children,
      stickyColumn = _ref5.stickyColumn,
      stickyColumnColor = _ref5.stickyColumnColor,
      hover = _ref5.hover,
      props = objectWithoutProperties(_ref5, ["href", "target", "className", "borders", "children", "stickyColumn", "stickyColumnColor", "hover"]);

  var _useStyles = useStyles({
    stickyColumn: stickyColumn,
    stickyColumnColor: stickyColumnColor
  }),
      row = _useStyles.row,
      stickyCol = _useStyles.stickyCol,
      hideRightBorder = _useStyles.hideRightBorder,
      hideTopHeaderBorder = _useStyles.hideTopHeaderBorder,
      hoverStyle = _useStyles.hoverStyle;

  var appliedBorder = null;

  if (stickyColumn) {
    switch (borders) {
      case 'all':
      case 'interior':
      case 'noOuterHorizontal':
      case 'noOuterVertical':
      case 'onlyVertical':
      case 'onlyHorizontal':
      case 'onlyInteriorVertical':
      case 'onlyInteriorHorizontal':
        appliedBorder = classNames__default["default"](hideRightBorder, hideTopHeaderBorder);
        break;

      case 'exterior':
      case 'noOuterHorizontal':
        appliedBorder = hideTopHeaderBorder;
        break;
    }
  }

  return React__default["default"].createElement(TableRow$1["default"], _objectSpread({
    className: classNames__default["default"](row, defineProperty({}, stickyCol, !!stickyColumn), defineProperty({}, appliedBorder, !!stickyColumn), defineProperty({}, hoverStyle, hover && stickyColumn), className),
    hover: hover
  }, props, {
    ref: ref
  }), href || borders || stickyColumn ? React.Children.map(children, function (child) {
    return ObjectHelper.isBlank(child) || child.type.displayName === 'TablePagination' ? child : React.cloneElement(child, {
      href: href,
      target: target,
      borders: borders,
      stickyColumn: stickyColumn
    });
  }) : children);
});

module.exports = TableRow;
